import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import ButtonRowGroup from './common/ButtonRowGroup';
import RawHtml from '../common/RawHtml';

import commonStyles from './styles';

const styles = (theme) => commonStyles(theme);

const DefaultBare = ({
  bottomContent,
  children,
  classes,
  hasFields,
  isProdStart,
  label,
  labelMobile,
  name,
  resources,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <input type="hidden" value="break-autocomplete" />
    <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

    <ErrorMsg name={name} type="group" />
    {isProdStart ? (
      <>
        {resources.content && <RawHtml>{resources.content}</RawHtml>}
        <div className={classnames('region-fields', classes.fields)}>{children}</div>
      </>
    ) : (
      <>
        <div className={classnames('region-fields', classes.fields)}>{children}</div>
        {resources.content && <RawHtml>{resources.content}</RawHtml>}
      </>
    )}

    <BottomContent className="bottomContent">{bottomContent}</BottomContent>

    <ButtonRowGroup groupName={name} />
  </>
);

DefaultBare.propTypes = {
  bottomContent: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasFields: PropTypes.bool,
  isProdStart: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  resources: PropTypes.objectOf(PropTypes.string).isRequired,
  subText: PropTypes.string,
};

DefaultBare.defaultProps = {
  bottomContent: '',
  hasFields: false,
  isProdStart: false,
  label: '',
  labelMobile: '',
  subText: '',
};

const DefaultStyled = withStyles(styles)(DefaultBare);

const mapStateToProps = ({ groups }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    /** HACK: This should be removed when the prod start page
     * is replaced with the product showcase
     */
    isProdStart: name === 'PROD_START',
    label: group.label,
    labelMobile: group.labelMobile,
    resources: group.resources,
    subText: group.subText,
  };
};

export default connect(mapStateToProps)(DefaultStyled);
